import type { DaySeparator } from '../../api/types'
import { KalenderIcon } from '../../components/Icons'
import { trennerTag } from '../../lib/ortszeit'
import { useTexte } from '../../texte'

/**
 * The day separator's line (#113, 1.85.0): "2. Okt. 2026 · Tag 3 ·
 * Freitag", and the explaining line under it.
 *
 * **Half-bold and one step above the running text** (from use: "fett
 * formatieren, nur leicht größer"), the whole width of the row, so that it
 * reads as a chapter line and not as a bubble. The weekday comes from
 * `Intl` with the app's locale (`trennerTag()`), the count from the server
 * ("Tag 3" / "Day 3") -- the one word the author chose per trip.
 *
 * The same component stands in the browser's book (`BuchPage`), where it
 * is the chapter heading.
 *
 * **Only a picture since #130 (1.115.0).** A separator is a post of its
 * own, and this line is its bubble: the long press, the menu and the
 * circle while deleting belong to the row in `Bubble`, from the same code
 * as every other kind. Until 1.114 the line hung over another post and
 * had its own menu, its own circle and its own gesture stops (1.86.4) --
 * all of that is gone with the attaching.
 */
export function Tagestrenner({ trenner, buch = false }: { trenner: DaySeparator; buch?: boolean }) {
  const t = useTexte()
  const { datum, wochentag } = trennerTag(trenner.day)
  const zaehler = t.chat.tagestrenner.zaehler(trenner.word, trenner.number)
  return (
    <div
      className={buch ? 'tagestrenner tagestrenner--buch' : 'tagestrenner'}
      data-tagestrenner={trenner.message_id}
      data-tag={trenner.day}
      data-nummer={trenner.number}
    >
      <p className="tagestrenner__zeile">
        <KalenderIcon size={16} />
        <span>{buch ? t.buch.kapitel(zaehler, wochentag, datum) : t.chat.tagestrenner.zeile(datum, zaehler, wochentag)}</span>
      </p>
      {trenner.note !== '' && <p className="tagestrenner__note">{trenner.note}</p>}
    </div>
  )
}
